export default (() => {
  // eslint-disable-next-line no-underscore-dangle
  if (!global || !global._babelPolyfill) {
    // eslint-disable-next-line global-require
    require('babel-polyfill');
  }
})();
